import { jsxs as i, jsx as l } from "react/jsx-runtime";
function r(t) {
  return /* @__PURE__ */ i(
    "svg",
    {
      width: "51",
      height: "50",
      viewBox: "0 0 51 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: [
        /* @__PURE__ */ i("g", { "clip-path": "url(#clip0_244030_448)", children: [
          /* @__PURE__ */ l(
            "path",
            {
              d: "M28.7856 24.9651L33.6599 30.5368L40.2151 34.7253L41.3553 25.0003L40.2151 15.4946L33.5345 19.174L28.7856 24.9651Z",
              fill: "#00832D"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M0.500122 33.8203V42.1074C0.500122 43.9997 2.03592 45.5359 3.92856 45.5359H12.2157L13.9317 39.2745L12.2157 33.8203L6.53017 32.1042L0.500122 33.8203Z",
              fill: "#0066DA"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M12.2156 4.39453L0.5 16.1101L6.53041 17.8222L12.2156 16.1101L13.9004 10.7303L12.2156 4.39453Z",
              fill: "#E94235"
            }
          ),
          /* @__PURE__ */ l("path", { d: "M0.500122 33.8242H12.2157V16.1101H0.500122V33.8242Z", fill: "#2684FC" }),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M47.699 9.35504L40.2151 15.495V34.7253L47.7302 40.8891C48.8551 41.7704 50.5008 40.9671 50.5008 39.5372V10.6794C50.5008 9.23355 48.8159 8.43429 47.699 9.35504Z",
              fill: "#00AC47"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M28.7856 24.9651V33.8201H12.2157V45.5357H36.7867C38.6793 45.5357 40.2151 43.9996 40.2151 42.1073V34.7253L28.7856 24.9651Z",
              fill: "#00AC47"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M36.7867 4.39453H12.2157V16.1101H28.7856V24.9652L40.2151 15.4947V7.82297C40.2151 5.93033 38.6793 4.39453 36.7867 4.39453Z",
              fill: "#FFBA00"
            }
          )
        ] }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_244030_448", children: /* @__PURE__ */ l(
          "rect",
          {
            width: "50",
            height: "50",
            fill: "rgb(var(--background-secondary))",
            transform: "translate(0.5)"
          }
        ) }) })
      ]
    }
  );
}
export {
  r as GoogleMeetIcon
};
